import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT} from '../../globalConstants/GlobalConstants';
import * as THREE from 'three';

const ANNOTATION_CONTACT_TEXT = 'geraldine@kahn-gallery.com';

const AnnotationsDB = [


    // {
    //     paintingId: 'greenPanel',
    //     videoId: 'Z9V6c',
    //     standaloneVideoElementId: 'Z9V6c',
    //     videoURL: 'Z9V6c.mp4',
    //     displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
    //     headerText: 'Sample',
    //     bodyText: null,
    //     displayMesh: 'Y',
    //     displayHeight: 90,
    //     videoAutoPlay: 'N',
    //     // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
    //     // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
    //     // videoButtonScale: {x: .2, y: .2, z: .2},
    //     // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
    //     videoTextureEncoding: THREE.sRGBEncoding,
    //
    // },


    /* Kahn Gallery */
    /* Wall 01 */

    {
        paintingId: 'W1V1',
        videoId: 'W1V1',
        standaloneVideoElementId: 'W1V1',
        videoURL: 'W1V1.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: `<h5>WELCOME</h5>`,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
    },
    {
        paintingId: 'W1P1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W1P1.jpg`,
        headerText: `<h5>JOSEPH</h5><h6>Boom Bubble Up, 2020</h6>`,
        emailSubjectText: `Boom Bubble Up, 2020, by Joseph at Kahn Gallery`,
        bodyText: `Oil, collages of old advertising posters and resin on wood<br>120 x 70 cm / 47,2 x 27,5 inches<br>Original artwork<br>£2,350 / $3,050 / 2600€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },

    {
        paintingId: 'W1P2',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W1P2.jpg`,
        headerText: `<h5>JOSEPH</h5><h6>God Bless, 2020</h6>`,
        emailSubjectText: `God Bless, 2020, by Joseph at Kahn Gallery`,
        bodyText: `Oil, collages of old advertising posters and resin on wood<br>85 x 110 cm / 33,8 x 43,3 inches<br>Original artwork<br>£2,530 / $3,300 / 2800€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W1P3',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W1P3.jpg`,
        headerText: `<h5>JOSEPH</h5><h6>Ice Cream Only Today, 2020</h6>`,
        emailSubjectText: `Ice Cream Only Today, 2020, by Joseph at Kahn Gallery`,
        bodyText: `Oil, collages of old advertising posters and resin on wood<br>85 x 110 cm / 33,8 x 43,3 inches<br>Original artwork<br>£2,530 / $3,300 / 2800€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W1P4',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W1P4.jpg`,
        headerText: `<h5>JOSEPH</h5><h6>Just Love, 2020</h6>`,
        emailSubjectText: `Just Love, 2020, by Joseph at Kahn Gallery`,
        bodyText: `Oil, collages of old advertising posters and resin on wood<br>70 x 100 cm / 27,5 x 39,3 inches<br>Original artwork<br>£2,000 / $2,600 / 2200€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W1P5',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W1P5.jpg`,
        headerText: `<h5>JOSEPH</h5><h6>Keep Your Magic, 2020</h6>`,
        emailSubjectText: `Keep Your Magic, 2020, by Joseph at Kahn Gallery`,
        bodyText: `Oil, collages of old advertising posters and resin on wood<br>80 x 115 cm / 31,5 x 45,2 inches<br>Original artwork<br>£3,500 / $4,580 / 3,900€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W1P6',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W1P6.jpg`,
        headerText: `<h5>JOSEPH</h5><h6>1cal, 2020</h6>`,
        emailSubjectText: `1cal, 2020, by Joseph at Kahn Gallery`,
        bodyText: `Oil, collages of old advertising posters and resin on wood<br>135 x 65 cm / 53 x 25,6 inches<br>Original artwork<br>£2,350 / $3,050 / 2600€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W1P7',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W1P7.jpg`,
        headerText: `<h5>JOSEPH</h5><h6>The Palm Hotel, 2020</h6>`,
        emailSubjectText: `The Palm Hotel, 2020, by Joseph at Kahn Gallery`,
        bodyText: `Oil, collages of old advertising posters and resin on wood<br>120 x 90 cm / 47,2 x 35,4 inches<br>Original artwork<br>£2,700 / $3,500 / 3000€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },

    {
        paintingId: 'W1P8',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W1P8.jpg`,
        headerText: `<h5>JOSEPH</h5><h6>True Love, 2020</h6>`,
        emailSubjectText: `True Love, 2020, by Joseph at Kahn Gallery`,
        bodyText: `Oil, collages of old advertising posters and resin on wood<br>90 x 70 cm / 35,4 x 27,5 inches<br>Original artwork<br>£2,800 / $2,200 / 2,400€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    /* Wall 01 */

    /* Wall 02 */
    {
        paintingId: 'W2P1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P1.jpg`,
        headerText: `<h5>ANNE VALVERDE</h5><h6>I work in an open space</h6>`,
        emailSubjectText: `I work in an open space by Anne Valverde at Kahn Gallery`,
        bodyText: `Argentic print mounted to Diasec<br>93 x 120 cm / 36,6 x 47,2 inches<br>Limited edition of 12`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W2P2',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P2.jpg`,
        headerText: `<h5>ANNE VALVERDE</h5><h6>Offline</h6>`,
        emailSubjectText: `Offline by Anne Valverde at Kahn Gallery`,
        bodyText: `Argentic print mounted to Diasec<br>93 x 120 cm / 36,6 x 47,2 inches<br>Limited edition of 12`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },

    {
        paintingId: 'W2P3',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P3.jpg`,
        headerText: `<h5>ANNE VALVERDE</h5><h6>Pool Night</h6>`,
        emailSubjectText: `Pool Night by Anne Valverde at Kahn Gallery`,
        bodyText: `Argentic print mounted to Diasec<br>112 x 112 cm / 44 x 44 inches<br>Limited edition of 12`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W2P4',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P4.jpg`,
        headerText: `<h5>ANNE VALVERDE</h5><h6>You are here</h6>`,
        emailSubjectText: `You are here by Anne Valverde at Kahn Gallery`,
        bodyText: `Argentic print mounted to Diasec<br>93 x 120 cm / 36,6 x 47,2 inches<br>Limited edition of 12`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W2P5',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P5.jpg`,
        headerText: `<h5>SAM PEACOCK</h5><h6>Georgham View, 2020</h6>`,
        emailSubjectText: `Georgham View, 2020 by Sam Peacock at Kahn Gallery`,
        bodyText: `Coffee CHALK paraffin wax AND OIL PAINT ON STEEL<br>85 x 35 cm / 33 x 15 inches<br>Original artwork<br>£850 / $1,100 / 950€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W2P6',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P6.jpg`,
        headerText: `<h5>SAM PEACOCK</h5><h6>Mandala Rise, 2020</h6>`,
        emailSubjectText: `Mandala Rise, 2020 by Sam Peacock at Kahn Gallery`,
        bodyText: `Coffee CHALK paraffin wax AND OIL PAINT ON STEEL<br>85 x 35 cm / 33 x 15 inches<br>Original artwork<br>£850 / $1,100 / 950€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W2P7',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P7.jpg`,
        headerText: `<h5>SAM PEACOCK</h5><h6>Ruggaton Ridge, 2020</h6>`,
        emailSubjectText: `Ruggaton Ridge, 2020 by Sam Peacock at Kahn Gallery`,
        bodyText: `Coffee CHALK paraffin wax AND OIL PAINT ON STEEL<br>85 x 35 cm / 33 x 15 inches<br>Original artwork<br>£850 / $1,100 / 950€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W2P8',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P8.jpg`,
        headerText: `<h5>SAM PEACOCK</h5><h6>Lobb Dune Cove, 2020</h6>`,
        emailSubjectText: `Lobb Dune Cove, 2020 by Sam Peacock at Kahn Gallery`,
        bodyText: `Coffee CHALK paraffin wax AND OIL PAINT ON STEEL<br>100 x 100 cm / 39 x 39 inches<br>Original artwork<br>£2,200 / $2,900 / 2,450€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W2P9',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P9.jpg`,
        headerText: `<h5>SAM PEACOCK</h5><h6>Hengest Bay, 2020</h6>`,
        emailSubjectText: `Hengest Bay, 2020 by Sam Peacock at Kahn Gallery`,
        bodyText: `Coffee CHALK paraffin wax AND OIL PAINT ON STEEL<br>100 x 150 cm / 40 x 60 inches<br>Original artwork<br>£2,800 / $3,650 / 3,100€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-sam-peacock/hengestbay',
    },
    {
        paintingId: 'W2P10',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W2P10.jpg`,
        headerText: `<h5>SAM PEACOCK</h5><h6>Smeaton, 2020</h6>`,
        emailSubjectText: `Smeaton, 2020 by Sam Peacock at Kahn Gallery`,
        bodyText: `Coffee CHALK paraffin wax AND OIL PAINT ON STEEL<br>100 x 150 cm / 40 x 60 inches<br>Original artwork<br>£2,800 / $3,650 / 3,100€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-sam-peacock/smeaton',
    },
    /* Wall 02 */

    /* Wall 03 */
    {
        paintingId: 'W3P1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P1.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Vintage Bouquet (Purple Leaves)</h6>`,
        emailSubjectText: `Vintage Bouquet (Purple Leaves) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on canvas<br>122 x 122 cm | 48 x 48 inches<br>Original artwork`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W3P2',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P2.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Vintage Bouquet (Blues and Greens)</h6>`,
        emailSubjectText: `Vintage Bouquet (Blues and Greens) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on canvas<br>122 x 122 cm | 48 x 48 inches<br>Original artwork`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W3P3',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P3.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Paper Bouquet (Colour Block)</h6>`,
        emailSubjectText: `Paper Bouquet (Colour Block) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on paper<br>76 x 56 cm | 30 x 22 inches<br>Original artwork<br>£1,040 / $ 1,350/ € 1,150`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W3P4',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P4.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Indigo Bouquet (Stripes and dot)</h6>`,
        emailSubjectText: `Indigo Bouquet (Stripes and dot) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on paper<br>76 x 56 cm | 30 x 22 inches<br>Original artwork<br>£1,040 / $ 1,350/ € 1,150`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-emily-filler/paper-bouquet-m4jt5-f8y6t-6rd4t-rm77y-2597x-9yr4k',
    },
    {
        paintingId: 'W3P5',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P5.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Paper Bouquet (Vintage Letter and blue vase)</h6>`,
        emailSubjectText: `Paper Bouquet (Vintage Letter and blue vase) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on paper<br>76 x 56 cm | 30 x 22 inches<br>Original artwork<br>£1,040 / $ 1,350/ € 1,150`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-emily-filler/paperbouquetvintageletterandbluevase',
    },
    {
        paintingId: 'W3P6',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P6.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Paper Bouquet (Orange and blue flower)</h6>`,
        emailSubjectText: `Paper Bouquet (Orange and blue flower) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on paper<br>76 x 56 cm | 30 x 22 inches<br>Original artwork<br>£1,040 / $ 1,350/ € 1,150`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-emily-filler/paperbouquetorangeandblueflower',
    },
    {
        paintingId: 'W3P7',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P7.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Paper Bouquet (Rainbow Flowers)</h6>`,
        emailSubjectText: `Paper Bouquet (Rainbow Flowers) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on paper<br>76 x 56 cm | 30 x 22 inches<br>Original artwork<br>£1,040 / $ 1,350/ € 1,150`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-emily-filler/paperbouquetrainbowflowers',
    },
    {
        paintingId: 'W3P8',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P8.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Paper Bouquet (Ochre hydrangea + red flower)</h6>`,
        emailSubjectText: `Paper Bouquet (Ochre hydrangea + red flower) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on paper<br>76 x 56 cm | 30 x 22 inches<br>Original artwork<br>£1,040 / $ 1,350/ € 1,150`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-emily-filler/paperbouquetochrehydrangeaandredflower',
    },
    {
        paintingId: 'W3P9',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P9.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Vintage Bouquet (Pink and White Flower)</h6>`,
        emailSubjectText: `Vintage Bouquet (Pink and White Flower) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on canvas<br>122 x 122 cm | 48 x 48 inches<br>Original artwork`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W3P10',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P10.jpg`,
        headerText: `<h5>EMILY FILLER</h5><h6>Vintage Bouquet (Green Leaf)</h6>`,
        emailSubjectText: `Vintage Bouquet (Green Leaf) by Emily Filler at Kahn Gallery`,
        bodyText: `Mixed media on canvas<br>122 x 122 cm | 48 x 48 inches<br>Original artwork`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W3P11',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P11.jpg`,
        headerText: `<h5>CORINNE DALLE-ORE</h5><h6>Ile des deux cocos, 2019</h6>`,
        emailSubjectText: `Ile des deux cocos, 2019 by Corinne Dalle-Ore at Kahn Gallery`,
        bodyText: `Acrylic and mixed media on canvas, varnish on top<br>80 x 80 cm / 31,5 x 31,5 inches<br>Original artwork`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-corinne-dalle-ore/iledesdeuxcocos',
    },
    {
        paintingId: 'W3P12',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P12.jpg`,
        headerText: `<h5>CORINNE DALLE-ORE</h5><h6>Tropical Fragrance, 2019</h6>`,
        emailSubjectText: `Tropical Fragrance, 2019 by Corinne Dalle-Ore at Kahn Gallery`,
        bodyText: `Acrylic and mixed media on canvas, varnish on top<br>80 x 80 cm / 31,5 x 31,5 inches<br>Original artwork`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: ' https://www.kahn-gallery.com/products-corinne-dalle-ore/tropical-fragrancec',
    },
    {
        paintingId: 'W3P13',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W3P13.jpg`,
        headerText: `<h5>CORINNE DALLE-ORE</h5><h6>Deep Splash, 2019</h6>`,
        emailSubjectText: `Deep Splash, 2019 by Corinne Dalle-Ore at Kahn Gallery`,
        bodyText: `Acrylic and mixed media on canvas, varnish on top<br>120 x 160 cm / 47,2 x 55,1 inches<br>Original artwork`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/products-corinne-dalle-ore/deep-splash',
    },
    /* Wall 03 */

    /* Wall 04 */
    {
        paintingId: 'W4P1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W4P1.jpg`,
        headerText: `<h5>CHRISTINE FLYNN</h5><h6>Campsbay Pool</h6>`,
        emailSubjectText: `Campsbay Pool by Christine Flynn at Kahn Gallery`,
        bodyText: `Photo printed on fine art gallery paper using archival pigment ink. Mounted to a 2" wood panel. Translucent spray overlay, finished in a high gloss resin.<br>Edition of 7<br>Numbered & Signed at the back.<br>152x 91cm / 60 x 36 inches<br>£4,500 / $5,850 / €5,000`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W4P2',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W4P2.jpg`,
        headerText: `<h5>CHRISTINE FLYNN</h5><h6>Botanical #2, 2020</h6>`,
        emailSubjectText: `Botanical #2, 2020 by Christine Flynn at Kahn Gallery`,
        bodyText: `Photo, acrylic, mixed media & walnut frame.<br>154 x 102 cm / 61 x 43 inches<br>Edition of 7<br>Numbered & Signed at the back.<br>£4,900 / $6,400 / €5,450`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/product-flynn/botanical%20purple',
    },
    {
        paintingId: 'W4P3',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W4P3.jpg`,
        headerText: `<h5>CHRISTINE FLYNN</h5><h6>Costa Rica Palm, 2020</h6>`,
        emailSubjectText: `Costa Rica Palm, 2020 by Christine Flynn at Kahn Gallery`,
        bodyText: `Photo, acrylic, mixed media & walnut frame.<br>154 x 102 cm / 61 x 43 inches<br>Edition of 7<br>Numbered & Signed at the back.<br>£4,900 / $6,400 / €5,450`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/product-flynn/costaricapalmsii',
    },
    {
        paintingId: 'W4P4',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W4P4.jpg`,
        headerText: `<h5>CHRISTINE FLYNN</h5><h6>Foggy Montauk, 2020</h6>`,
        emailSubjectText: `Foggy Montauk, 2020 by Christine Flynn at Kahn Gallery`,
        bodyText: `Photo, acrylic, mixed media framed in walnut.<br>154 x 102 cm / 61 x 43 inches<br>Edition of 7.<br>Numbered & Signed at the back.<br>£4,900 / $6,400 / €5,450`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/product-flynn/foggymontauk',
    },
    {
        paintingId: 'W4P5',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W4P5.jpg`,
        headerText: `<h5>CHRISTINE FLYNN</h5><h6>Venice Surfers</h6>`,
        emailSubjectText: `Venice Surfers by Christine Flynn at Kahn Gallery`,
        bodyText: `Photo printed on fine art gallery paper using archival pigment ink. Mounted to a 2" wood panel. Translucent spray overlay, finished in a high gloss resin.<br>152 x 91 cm / 60 x 36 inches<br>Edition of 7<br>Numbered & Signed at the back.<br>£4,500 / $5,850 / €5,000`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        ContactURL: 'https://www.kahn-gallery.com/product-flynn/venicesurfers',
    },
    /* Wall 04 */

    /* Wall 05 */
    {
        paintingId: 'W5AP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W5AP1.jpg`,
        headerText: `<h5>ANNE VALVERDE</h5><h6>Dream Deck II</h6>`,
        emailSubjectText: `Dream Deck II by Anne Valverde at Kahn Gallery`,
        bodyText: `Argentic print mounted to Diasec<br>112 x 112 cm / 44 x 44 inches<br>Limited edition of 12`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W5BP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W5BP1.jpg`,
        headerText: `<h5>ANNE VALVERDE</h5><h6>Arizona Dream</h6>`,
        emailSubjectText: `Arizona Dream by Anne Valverde at Kahn Gallery`,
        bodyText: `Argentic print mounted to Diasec<br>112 x 112 cm / 44 x 44 inches<br>Limited edition of 12`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    /* Wall 05 */

    /* Wall 06 */
    {
        paintingId: 'W6AP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W6AP1.jpg`,
        headerText: `<h5>ANNE VALVERDE</h5><h6>Endless</h6>`,
        emailSubjectText: `Endless by Anne Valverde at Kahn Gallery`,
        bodyText: `Argentic print mounted to Diasec<br>93 x 120 cm / 36,6 x 47,2 inches<br>Limited edition of 12`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W6BP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W6BP1.jpg`,
        headerText: `<h5>ANNE VALVERDE</h5><h6>Love is Pink</h6>`,
        emailSubjectText: `Love is Pink by Anne Valverde at Kahn Gallery`,
        bodyText: `Argentic print mounted to Diasec<br>93 x 120 cm / 36,6 x 47,2 inches<br>Limited edition of 12`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    /* Wall 06 */

    /* Wall 07 */
    {
        paintingId: 'W7AP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W7AP1.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Sad Tree 1</h6>`,
        emailSubjectText: `Sad Tree 1 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Shadowgraph and cyanotype on Fabriano Rosaspina paper<br>70 x 50 cm / 27,5 x 19,6 inches<br>Original artwork<br>£1,100 / $1,500 / 1,250€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W7AP2',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W7AP2.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Sad Tree 2</h6>`,
        emailSubjectText: `Sad Tree 2 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Shadowgraph and cyanotype on Fabriano Rosaspina paper<br>70 x 50 cm / 27,5 x 19,6 inches<br>Original artwork<br>£1,100 / $1,500 / 1,250€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    // Wall 7b
    {
        paintingId: 'W7BP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W7BP1.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>Klimt and the tree of life</h6>`,
        emailSubjectText: `Klimt and the tree of life by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>150 x 100 cm / 60 x 40 inches<br>Original artwork<br>£5,400 / $7,000 / 6,000€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    /* Wall 07 */

    /* Wall 08 */
    {
        paintingId: 'W8BV1',
        videoId: 'W8BV1',
        standaloneVideoElementId: 'W8BV1',
        videoURL: 'W8BV1.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE,
        headerText: `<h5>WELCOME</h5>`,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
    },
    {
        paintingId: 'W8AP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8AP1.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Brick Nursery 1</h6>`,
        emailSubjectText: `Brick Nursery 1 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Ceramic<br>40 x 32 cm / 17,5 x 12,6 inches<br>Original artwork<br>£700/ $900 / 750€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W8AP2',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8AP2.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Brick Nursery 2</h6>`,
        emailSubjectText: `Brick Nursery 2 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Ceramic<br>40 x 32 cm / 17,5 x 12,6 inches<br>Original artwork<br>£700/ $900 / 750€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W8AP3',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8AP3.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Brick Nursery 3</h6>`,
        emailSubjectText: `Brick Nursery 3 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Ceramic<br>43 x 35 cm / 17 x 13,7 inches<br>Original artwork<br>£750/ $950 / 800€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W8AP4',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8AP4.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Brick Nursery 4</h6>`,
        emailSubjectText: `Brick Nursery 4 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Ceramic<br>43 x 35 cm / 17 x 13,7 inches<br>Original artwork<br>£750/ $950 / 800€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },

    {
        paintingId: 'W8AP5',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8AP5.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Dark Physalis 1</h6>`,
        emailSubjectText: `Dark Physalis 1 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Shadowgraph and cyanotype on Fabriano Rosaspina paper<br>70 x 50 cm / 27,5 x 19,6 inches<br>Original artwork<br>£1,100 / $1,500 / 1,250€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W8AP6',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8AP6.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Dark Physalis 2</h6>`,
        emailSubjectText: `Dark Physalis 2 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Shadowgraph and cyanotype on Fabriano Rosaspina paper<br>70 x 50 cm / 27,5 x 19,6 inches<br>Original artwork<br>£1,100 / $1,500 / 1,250€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W8AP7',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8AP7.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Light Physalis 1</h6>`,
        emailSubjectText: `Light Physalis 1 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Shadowgraph and cyanotype on Fabriano Rosaspina paper<br>70 x 50 cm / 27,5 x 19,6 inches<br>Original artwork<br>£1,100 / $1,500 / 1,250€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W8BP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8BP1.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>Georgia Flowers, 2018</h6>`,
        emailSubjectText: `Georgia Flowers, 2018 by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>102 x 76 cm / 40 x 30 inches<br>Original artwork<br>£3,200 / $4,150 / 3,500€<br> In 1928, Georgia O’Keeffe is a successful artist. She started her flowers series 2 years earlier and it will become her signature. She declared that “I'll paint what I see - what the flower is to me but I'll paint it big and they will be surprised into taking time to look at it - I will make even busy New Yorkers take time to see what I see of flowers." On April 9, Alfred Stieglitz, her husband and art dealer sent a press release announcing the amazing sale of 6 paintings. It will turn out to be an arranged deal with a friend but from that point, her pricing will rise.`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        mediaCarouselLinkLabel: `IN THE STUDIO`,
        hasMediaCarousel: 'Y',
        mediaObjects: [{type: 'image', link:
                '/paintings/W8BP1a.jpg'}, {type: 'image', link:
                '/paintings/W8BP1b.jpg'},],
    },
    {
        paintingId: 'W8BP2',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8BP2.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>Joan Sunflowers, 2019</h6>`,
        emailSubjectText: `Joan Sunflowers, 2019 by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>36 x 28 cm / 14 x 11 inches<br>Original artwork<br>£650 / $850 / 700€<br>In 1968, the American abstract expressionist artist Joan Mitchell, moved from Paris to Normandy where she settled. In that new studio, she started to work on a new body of works inspired by Vincent Van Gogh’s sunflowers, a theme she will explore until the end of her career.<br>As for Van Gogh, the series was created in the context of a move from Paris to the French countryside and with a sense of promise. In this Post dated on the day of the anniversary of Van Gogh's death, Mitchell shares a detail of Sunflowers. Her comment is based on her quotes “Sunflowers are something I feel very intensely. They look so wonderful when young and they are so very moving when they are dying. I don’t like fields of sunflowers. I like them alone or, of course, painted by Van Gogh.” and “It's a yellow painting. There's hope.”<br>
Her partner, the artist Jean Paul Riopelle, refers to that move and the mood of renewal. Her friend Williem de Kooning declared “What fascinates me about Van Gogh is that his sun dries up everything. Maybe he was melodramatic but my point really is...if you are a painter you have to face that self-consciousness“. Her life long friend Grace Hartigan also likes the post.`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        mediaCarouselLinkLabel: `IN THE STUDIO`,
        hasMediaCarousel: 'Y',
        mediaObjects: [{type: 'image', link:
                '/paintings/W8BP2a.jpg'}, {type: 'video', link:
                '/videos/W8BP2b.mp4'},],
    },
    {
        paintingId: 'W8BP3',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8BP3.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>David’s watery process, 2020</h6>`,
        emailSubjectText: `David’s watery process, 2020 by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>36 x 28 cm / 14 x 11 inches<br>Original artwork<br>SOLD<br> In the summer of 1978, David Hockney worked for 6 weeks at Tyler Graphics run by the master printer Kenneth Tyler. He discovered paper pulp and was so excited by this new medium that he came back to the subject of pools that he had not touched for years. Just like Matisse discovered a new way of creating with the paper cuts. Hockney’ was struck by how much water was involved in the process of paper pulp and said “I love new mediums (…) I think mediums can (…) excite you: they always let you do something in a different way, even if you take the same subject.” This series will mark a new development for the artist.<br>Kenneth Tyler, worked with the best artists of his day with the motto that “great prints are made only by great artists”. Andy Warhol who took the photo of David Hockney, teases him about it.`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        mediaCarouselLinkLabel: `IN THE STUDIO`,
        hasMediaCarousel: 'Y',
        mediaObjects: [{type: 'image', link:
                '/paintings/W8BP3a.jpg'}, {type: 'image', link:
                '/paintings/W8BP3b.jpg'},],
    },
    {
        paintingId: 'W8BP4',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8BP4.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>Lee Sun Woman, 2020</h6>`,
        emailSubjectText: `Lee Sun Woman, 2020 by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>102 x 76 cm / 40 x 30 inches<br>Original artwork<br>£3,200 / $4,150 / 3,500€<br>Executed in the summer of 1957, a year after the death of her husband Jackson Pollock, Sun Woman I is one of the largest and most important paintings from Krasner’s celebrated Earth Green series. The series represents a rebirth, both literally and metaphorically and is widely considered as the pivotal moment of her career.<br>In this POST shared on the anniversary of Pollock's death, Krasner says “painting is not separate from life. it is like asking - do I want to live? my answer is yes - and I paint”.<br>It was exhibited at Martha Jackson Gallery in 1958, which prompted art critic Clement Greenberg to offer her a solo show the following year.<br>In his introduction to the exhibition, writer, Robert Friedman wrote "In looking at these paintings, listening to them, feeling them, I know that this work - Lee Krasner's most mature and personal, as well as most joyous and positive, to date - was done entirely in the last year and a half, a period of profound sorrow for the artist.  The paintings are a stunning affirmation of life.”`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        mediaCarouselLinkLabel: `IN THE STUDIO`,
        hasMediaCarousel: 'Y',
        mediaObjects: [{type: 'image', link:
                '/paintings/W8BP4a.jpg'},],
    },
    {
        paintingId: 'W8BP5',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8BP5.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>Vincent and Hokusai Irises, 2019</h6>`,
        emailSubjectText: `Vincent and Hokusai Irises, 2019 by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>102 x 76 cm / 40 x 30 inches<br>Original artwork<br>£3,200 / $4,150 / 3,500€<br>As many impressionists, Van Gogh revered Japanese artists, declaring Hokusai “admirable and he had a large collection of prints. He was inspired by them and copied their work, explaining “ why it seems good to me to copy them(…): We painters are always asked to compose ourselves and to be nothing but composers. but in music (…) a composer’s interpretation is something, and it isn’t a hard and fast rule that only the composer plays his own compositions.(…)So then my brush goes between my fingers as if it were a bow on the violin and absolutely for my pleasure.”<br>The Irises were exhibited in 1889 at the fifth exhibition of the Société des Artistes Indépendants, held in Paris from 3 September to 4 October 1889. Theo described the exhibition saying that the painting “looks extremely well. (…) it strikes you from a long way off. It’s a fine study, full of air and life.”<br>In his review of the exhibition for La Vogue (September 1889), the art critic Felix Fénéon wrote: “His Irises violently shred their purple parts over their lath-like leaves. Mr van Gogh is a diverting colourist even in eccentricities like his Starry Night”`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        mediaCarouselLinkLabel: `IN THE STUDIO`,
        hasMediaCarousel: 'Y',
        mediaObjects: [{type: 'image', link:
                '/paintings/W8BP5a.jpg'},{type: 'image', link:
                '/paintings/W8BP5b.jpg'},{type: 'image', link:
                '/paintings/W8BP5c.jpg'},{type: 'image', link:
                '/paintings/W8BP5d.jpg'},],
    },
    {
        paintingId: 'W8BP6',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8BP6.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>Vincent, souvenir de mauve, 2019</h6>`,
        emailSubjectText: `Vincent, souvenir de mauve, 2019 by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>102 x 76 cm / 40 x 30 inches<br>Original artwork<br>£3,200 / $4,150 / 3,500€<br>Souvenir de Mauve (left) and its repetition: Pink peach tree (right) are part of the Orchard series executed in Provence in the spring of 1888. Van Gogh worked with optimism on about 14 paintings of flowering trees, representing awakening and hope. In one of his letters to his brother Theo, he said “I feel I’m in Japan. That’s why (…) I don’t despair of success in this enterprise of going on a long journey in the south. Here I’m seeing new things, I’m learning”. While doing the series, he learnt of the passing of his cousin Anton Mauve, a painter too, who had helped him in his youth. Vincent dedicated a painting and sent it as a gift to his widow. He did a repetition of the painting in the next weeks and was done in April.<br>Meanwhile, in March 1888, Paul Gauguin wrote “I see that you’re in a good spot to study the sun that enchants you, and you’re working all the better because the subject grips you. (…) I’m in a state of constant agony here; money worries are the only ones that have an effect on me.(…) Pont-Aven is very dreary at the moment because of the bad weather, continual wind and rain, and I’m waiting for the fine days to get back to work, which I’ve neglected a bit owing to illness.”`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        mediaCarouselLinkLabel: `IN THE STUDIO`,
        hasMediaCarousel: 'Y',
        mediaObjects: [{type: 'image', link:
                '/paintings/W8BP6a.jpg'},{type: 'image', link:
                '/paintings/W8BP6b.jpg'},{type: 'image', link:
                '/paintings/W8BP6c.jpg'},],
    },
    {
        paintingId: 'W8BP7',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W8BP7.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>Alma resurrection, 2020</h6>`,
        emailSubjectText: `Alma resurrection, 2020 by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>61 x 46 cm / 24 x 18 inches<br>Original artwork<br>On April 24, 1966, Alma Thomas had her first retrospective exhibit at the Howard University. She showed Earth Paintings, a series of nature inspired abstract works, including Resurrection (1966) bought in 2014 for the White House collection. In her journals, she wrote “colour is life, for a world without colour appears to us as dead” and “the rainbow is a symbol of peace”.<br>James Herring, Prof. Emeritus wrote the forewords of the catalog “Though it is a retrospective show, (…) I fully expect that her public (…) will demand yet another one-woman show in the next few years”.<br>For this exhibition, she had a supportive review in The Washington Post written by Helen Hoffman titled "colourful abstract reflects her spirit” and by artist and art historian Jacob Kainen.<br>In 1972 she was the first African-American woman to hold a solo exhibition at the Whitney Museum of American Art. She wrote that when she was a kid “one of the things we couldn’t do was go into museums, let alone think of hanging our pictures there. My, times have changed. Just look at me now.”`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
        mediaCarouselLinkLabel: `IN THE STUDIO`,
        hasMediaCarousel: 'Y',
        mediaObjects: [{type: 'image', link:
                '/paintings/W8BP7a.jpg'},{type: 'image', link:
                '/paintings/W8BP7b.jpg'},{type: 'image', link:
                '/paintings/W8BP7c.jpg'},],
    },
    /* Wall 08 */

    /* Wall 09 */
    /* Wall 9a */
    {
        paintingId: 'W9AP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W9AP1.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Plant 3</h6>`,
        emailSubjectText: `Plant 3 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Shadowgraph and cyanotype on Fabriano Rosaspina paper<br>100 x70 cm / 39 x 27,5 inches<br>Original artwork<br>£1,500 / $2,000 / 1,700€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    {
        paintingId: 'W9AP2',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W9AP2.jpg`,
        headerText: `<h5>PHILIPPE RINGOT</h5><h6>Orange Worms 1</h6>`,
        emailSubjectText: `Orange Worms 1 by Philippe Ringot at Kahn Gallery`,
        bodyText: `Shadowgraph and cyanotype on Fabriano Rosaspina paper<br>70 x 50 cm / 27,5 x 19,6 inches<br>Original artwork<br>£1,100 / $1,500 / 1,250€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    /* Wall 9b */
    {
        paintingId: 'W9BP1',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W9BP1.jpg`,
        headerText: `<h5>LAURENCE DE VALMY</h5><h6>KJ MARHSALL</h6>`,
        emailSubjectText: `KJ MARSHALL by Laurence De Valmy at Kahn Gallery`,
        bodyText: `Acrylic on canvas<br>150 x 100 cm / 60 x 40 inches<br>Original artwork<br>£5,400 / $7,000 / 6,000€`,
        isSendTo: 'Y',
        EnquireEmail: 'geraldine@kahn-gallery.com',
    },
    /* Wall 09 */
    /* Kahn Gallery */

];

export {AnnotationsDB, ANNOTATION_CONTACT_TEXT};
